import { observer } from "mobx-react-lite";
import { useState } from "react";
import "./aboutus.css";

const AboutUs = () => {
 const [privacyOpen, setPrivacyOpen] = useState(false);
 const [termsOpen, setTermsOpen] = useState(false);
 const [responsibilityOpen, setResponsibilityOpen] = useState(false);

 return (
  <div className="p-2">
   <h2 className="about_main-title">
    En esta página encontrará toda la información que necesita sobre nuestro sitio web.
    Nos alegra que estés aquí y esperamos que encuentres respuestas a tus preguntas.
    todas tus preguntas. Nos alegra que nos haya encontrado y esperamos que
    Que aquí encontrarás respuestas a todas tus preguntas. Que tengas uno bonito
    ¡hojeada!
   </h2>
   <div>
    <h3
     className="about-info-item-title"
     onClick={() => setPrivacyOpen(!privacyOpen)}
    >
     <strong>Política de privacidad</strong>{" "}
     <svg
      width="9"
      height="9"
      viewBox="0 0 9 9"
      xmlns="http://www.w3.org/2000/svg"
     >
      <path
       fill-rule="evenodd"
       clip-rule="evenodd"
       d="M0.707 0V2.001H5.292L0 7.293L1.414 8.707L6.706 3.415V8H8.707V0H0.707Z"
      ></path>
     </svg>
    </h3>
    {privacyOpen ? (
     <div className="about-info-item-text">
      <p>
       **Política de Privacidad** (en adelante, la "Política") establece las reglas
       uso de los datos personales recopilados de los Usuarios de los sitios web
       sitios web de su propiedad y operados (en adelante denominados
       "Páginas de la Empresa") por el administrador de estas páginas (en adelante,
       "Compañía"). Esta Política de Privacidad se aplica a todos
       Usuarios del sitio. Todos los términos y definiciones utilizados en el texto.
       Las políticas se interpretan de acuerdo con la legislación aplicable.
       Federación de Rusia, en particular con el "Reglamento general sobre
       protección de datos". Los usuarios consienten expresamente el tratamiento
       sus datos personales en la forma descrita en esta Política. Usando
       de los Sitios web de la Compañía constituye la aceptación incondicional de esta Política y
       condiciones de procesamiento de la información. El usuario no debe utilizar
       Los sitios web de la empresa si no está de acuerdo con los términos de esta Política.
       Traducido de DeepL.com (versión gratuita)
      </p>
      <p>
       **1. Datos personales tratados por la Compañía** 1.1. Sitios web empresa
       recopila, accede y utiliza los datos personales del Usuario,
       información técnica y de otro tipo relacionada con los Usuarios a los efectos
       especificado en la Política. 1.2. La información técnica no se considera datos.
       turismos. La empresa utiliza “cookies” para identificar al Usuario
       en el sitio web . Las cookies son archivos de texto que permiten
       procesar información sobre la actividad del Usuario, incluyendo qué
       páginas visitadas por el Usuario y cuánto tiempo pasó en ellas. El usuario puede
       deshabilite el uso de cookies en la configuración de su navegador. 1.3. Para
       También se considera información técnica aquella información que se transmite
       automáticamente a la Compañía cuando utiliza los Sitios web de la Compañía por
       software instalado en los dispositivos del usuario. 1.4. Datos
       Los datos personales del Usuario son la información que el Usuario proporciona a la Empresa
       al completar formularios en los sitios web de la Compañía y cuando
       uso posterior de los Sitios. Información necesaria para la prestación.
       Los servicios prestados por la Compañía están especialmente marcados. Se proporciona otra información.
       a discreción del Usuario. 1.5. La Compañía también podrá procesar datos,
       que se hayan hecho públicos en el sitio web o que deban hacerse públicos
       publicado o divulgado obligatoriamente de conformidad con la legislación rusa
       . 1.6. Compañía
      </p>
      <p>
       **2. Finalidades del tratamiento de los datos personales del Usuario** 2.1. Básico
       La finalidad de la Compañía al recabar datos personales es proporcionar
       servicios de información y asesoramiento a los Usuarios. Los usuarios están de acuerdo
       que la Compañía también podrá utilizar sus datos personales para: <br />-
       identificación de las partes en el ámbito de los servicios prestados; <br />
       - proporcionar servicios y soporte a los Usuarios; - mejora de la calidad
       servicios, conveniencia de su prestación, desarrollo de sitios web de la empresa, resolución de problemas
       problemas técnicos o de seguridad; <br />
       - realizar análisis para ampliar y mejorar los servicios y contenidos
       información y publicidad; <br />
       - informar a los Usuarios sobre servicios, marketing dirigido,
       actualizaciones y ofertas publicitarias acordes a sus preferencias; <br />
       - segmentar el contenido publicitario; envío personalizado
       mensajes de marketing por correo electrónico, teléfono o mensaje de texto;{" "}
       <br />
       - realizar investigaciones estadísticas o de otro tipo sobre datos anonimizados
       datos . <br />
       2.2. La Compañía utiliza la información técnica para los fines descritos en
       página en el punto 2.1.
      </p>

      <p>
       **3. Las condiciones y modalidades del tratamiento de los datos personales del Usuario y
       su cesión a terceros** <br /> <br />
       3.1. El usuario consiente el tratamiento de sus datos personales
       mediante el envío de una solicitud (cualquier solicitud escrita que contenga datos)
       datos de contacto). <br />
       3.2. El tratamiento incluye la recopilación, registro, sistematización,
       recopilar, almacenar, actualizar, modificar, extraer,
       uso, transferencia (distribución, puesta a disposición,
       acceso), anonimización, bloqueo, eliminación y destrucción de datos
       datos personales. <br />
       3.3. Los datos personales del Usuario son tratados de forma confidencial, salvo en
       casos en que el Usuario haya facilitado voluntariamente dicha información a
       acceso público. <br />
       3.4. La Empresa tiene el derecho de transferir los datos personales del Usuario a terceros
       tercero en los casos siguientes:
       - El usuario ha dado su consentimiento; - la transferencia es necesaria para
       el uso por parte del Usuario del servicio de los Sitios Web de la Empresa o para realizar
       acuerdos con el Usuario; <br />
       - la transferencia se realiza a las autoridades competentes de conformidad con la legislación rusa
       ley ; <br />
       - para proteger los derechos e intereses legales de la Compañía o de terceros cuando
       El Usuario viola los Acuerdos, esta Política o los Términos de Uso
       ciertos servicios; <br />
       - de conformidad con el art.
       <br />
      </p>

      <p>
       **4. Medidas utilizadas por la Compañía para proteger los datos personales
       Usuario
       <br />
       4.1. La Compañía toma las medidas legales necesarias y suficientes,
       organizativas y técnicas para proteger los datos personales del Usuario
       contra el acceso no autorizado o accidental, la destrucción,
       modificación, bloqueo, copia, distribución y también contra
       otras actividades ilegales de terceros.
      </p>
      <p>
       **5. Resolución de disputas**
       5.1. Cualquier controversia que surja de las relaciones regidas por este
       La política se decidirá de conformidad con la legislación aplicable de la Federación.
       Ruso. <br />
       5.2. Cumplimiento del procedimiento de resolución preliminar de disputas (quejas)
       es obligatorio.
      </p>
      <p>
       **6. Términos adicionales**
       <br />6.1. La Compañía tiene el derecho de cambiar esta Política de Privacidad sin
       Consentimiento del usuario. 6.2. La nueva Política entra en vigor a partir de su publicación.
       publicación a menos que se indique lo contrario. 6.3. Uso continuo
       Los sitios web de la Compañía después de que se introduzcan dichos cambios en el sitio web constituyen la aceptación
       estos cambios por parte del Usuario.
      </p>
      <div
       className="about-info-close-modal"
       onClick={() => setPrivacyOpen(!privacyOpen)}
      >
       Cerrar
      </div>
     </div>
    ) : (
     false
    )}
   </div>

   <div>
    <h3
     className="about-info-item-title"
     onClick={() => setTermsOpen(!termsOpen)}
    >
     <strong>Políticas de usuario</strong>{" "}
     <svg
      width="9"
      height="9"
      viewBox="0 0 9 9"
      xmlns="http://www.w3.org/2000/svg"
     >
      <path
       fill-rule="evenodd"
       clip-rule="evenodd"
       d="M0.707 0V2.001H5.292L0 7.293L1.414 8.707L6.706 3.415V8H8.707V0H0.707Z"
      ></path>
     </svg>
    </h3>
    {termsOpen ? (
     <div className="about-info-item-text">
      <p>
       **Política de Privacidad** (en adelante - Política) define las reglas de uso
       a través de datos personales recopilados de los usuarios del sitio web
       propiedad y operada (en adelante, "Sitios web de la empresa") por
       administradores de dichos sitios web (en adelante, la Compañía). Esta política
       La Política de Privacidad se aplica a todos los usuarios de los sitios web de la empresa. Todo
       Los términos y definiciones utilizados en el texto de la Política se interpretan de conformidad con
       la legislación aplicable de la Federación de Rusia, en particular
       "Reglamento General de Protección de Datos". Usuarios claramente
       Consentimiento para el tratamiento de sus datos personales en la forma descrita en
       esta Política. Al utilizar los Sitios de la Compañía, usted consiente incondicionalmente a
       la aceptación por parte del Usuario de esta Política y de lo anteriormente mencionado
       condiciones para el tratamiento de datos. No debe utilizar los Sitios
       Compañía si no está de acuerdo con los términos establecidos en este
       Política.
      </p>
      <p>
       **1. Datos personales tratados por la Compañía** 1.1. Sitios web de la empresa
       recopilar, acceder y utilizar los datos personales del Usuario, y
       También información técnica y otra información relativa a los Usuarios,
       los fines especificados en la Política. 1.2. No se considera información técnica
       para datos personales. La empresa utiliza "cookies" con la finalidad de
       Identificación del usuario. Las cookies son archivos de texto que la Empresa
       podrá utilizar para procesar información sobre la actividad del Usuario,
       incluyendo información sobre qué páginas visitó el Usuario y durante cuánto tiempo
       Estaba en el sitio. El usuario puede desactivar el uso de cookies
       cookie en la configuración de su navegador. 1.3 La información se considera
       También información técnica que se envía automáticamente a
       La Compañía en el proceso de uso de los Sitios Web de la Compañía a través de software
       instalados en los dispositivos del Usuario. 1.4. Datos personales
       la información del Usuario es la información que el Usuario proporciona a la Compañía durante
       rellenar formularios en los sitios web de la Compañía y en el sitio web durante
       Uso de los sitios web de la empresa. Información necesaria para prestar servicios
       por la Compañía están especialmente marcados como . El resto de la información está ahí.
       proporcionados por el Usuario voluntariamente. 1.5. La empresa también puede
       tratar datos que se hayan hecho públicos o cuya publicación
      </p>

      <p>
       **1. Datos personales tratados por la Compañía** 1.1. Sitios web de la empresa
       recopilar, acceder y utilizar los datos personales del Usuario, y
       También información técnica y otra información relativa a los Usuarios,
       los fines especificados en la Política. 1.2. No se considera información técnica
       para datos personales. La empresa utiliza "cookies" con la finalidad de
       Identificación del usuario. Las cookies son archivos de texto que la Empresa
       podrá utilizar para procesar información sobre la actividad del Usuario,
       incluyendo información sobre qué páginas visitó el Usuario y durante cuánto tiempo
       Estaba en el sitio. El usuario puede desactivar el uso de cookies
       cookie en la configuración de su navegador. 1.3 La información se considera
       También información técnica que se envía automáticamente a
       La Compañía en el proceso de uso de los Sitios Web de la Compañía a través de software
       instalados en los dispositivos del Usuario. 1.4. Datos personales
       La información del Usuario es la información que el Usuario proporciona a la Compañía durante
       rellenar formularios en los sitios web de la Compañía y en el sitio web durante
       Uso de los sitios web de la empresa. Información necesaria para prestar servicios
       por la Compañía están especialmente marcados como . El resto de la información está ahí.
       proporcionados por el Usuario voluntariamente. 1.5. La empresa también puede
       tratar datos que se hayan hecho públicos o cuya publicación
      </p>

      <p>
       **3. Las condiciones y modalidades del tratamiento de los datos personales de los Usuarios y
       su cesión a terceros** 3.1. El usuario consiente
       tratamiento de sus datos personales mediante el envío de una solicitud a
       dirección (cualquier solicitud escrita que contenga datos de contacto). 3.2.
       El tratamiento de los datos personales del Usuario incluye la recogida,
       registrar, sistematizar, recopilar, almacenar,
       actualizar, modificar, extraer, utilizar,
       transmisión (distribución, intercambio, acceso), anonimización,
       bloqueo, eliminación y destrucción de los datos personales del Usuario. 3.3.
       Se mantiene la confidencialidad de los datos personales del Usuario, salvo
       casos en los que el propio Usuario haya facilitado voluntariamente información sobre
       acceso público a un número ilimitado de personas. 3.4. la empresa tiene
       el derecho a transferir los datos personales del Usuario a terceros en los siguientes casos:
       casos:
       - El Usuario ha consentido dichas acciones; <br />
       - la transferencia sea necesaria para el uso por parte del Usuario
       un servicio específico de los Sitios de la Compañía o para la ejecución de un contrato específico o
       acuerdos con el Usuario; <br />- la transferencia se realiza a personas autorizadas
       organismos públicos de la Federación de Rusia sobre la base y de conformidad con el procedimiento
       definido por .
      </p>
      <p>
       **4. Medidas utilizadas por la Compañía para proteger los datos personales
       Usuario ** 4.1. La empresa toma las medidas necesarias y suficientes
       legales, organizativas y técnicas para proteger los datos personales
       Usuario contra acceso no autorizado o accidental,
       destrucción, modificación, bloqueo, copia,
       difusión, así como contra otras actividades ilegales de personas
       tercios.
      </p>
      <p>
       **4. Medidas utilizadas por la Compañía para proteger los datos personales
       Usuario ** 4.1. La empresa toma las medidas necesarias y suficientes
       legales, organizativas y técnicas para proteger los datos personales
       Usuario contra acceso no autorizado o accidental,
       destrucción, modificación, bloqueo, copia,
       difusión, así como contra otras actividades ilegales de personas
       tercios.
      </p>
      <p>
       **6. Disposiciones adicionales** 6.1. La empresa tiene derecho a modificar
       esta Política de Privacidad sin el consentimiento del Usuario. 6.2. Nueva política
       La Política de Privacidad entra en vigor a partir de la fecha de su publicación, a menos que se publique una nueva versión.
       La política establece lo contrario. 6.3. Su uso continuado de los Sitios de la Compañía después
       dichos cambios confirman la aceptación de dichos cambios por parte del Usuario.
      </p>
      <div
       className="about-info-close-modal"
       onClick={() => setTermsOpen(!termsOpen)}
      >
       Cerca
      </div>
     </div>
    ) : (
     false
    )}
   </div>

   <div>
    <h3
     className="about-info-item-title"
     onClick={() => setResponsibilityOpen(!responsibilityOpen)}
    >
     <strong>Reserva</strong>{" "}
     <svg
      width="9"
      height="9"
      viewBox="0 0 9 9"
      xmlns="http://www.w3.org/2000/svg"
     >
      <path
       fill-rule="evenodd"
       clip-rule="evenodd"
       d="M0.707 0V2.001H5.292L0 7.293L1.414 8.707L6.706 3.415V8H8.707V0H0.707Z"
      ></path>
     </svg>
    </h3>
    {responsibilityOpen ? (
     <div className="about-info-item-text">
      <p>
       Si necesita información adicional o tiene alguna pregunta sobre
       Nuestro descargo de responsabilidad, por favor contáctenos en
       por correo electrónico: Gever.menrevons@bigmir.net.
      </p>
      <p>
       Toda la información contenida en este sitio web se proporciona de buena fe y
       Sólo para fines informativos. No garantizamos la integridad,
       fiabilidad o exactitud de la información. Cualquier acción tomada
       Con base en la información contenida en el sitio web, el usuario toma sus propias decisiones.
       riesgo. No somos responsables de ninguna pérdida o daño.
       relacionados con su uso de nuestro sitio web.
      </p>
      <p>
       Cuando utiliza enlaces a sitios externos, es posible que esos sitios...
       tienen diferentes políticas de privacidad y términos de uso del sitio web.
      </p>

      <div
       className="about-info-close-modal"
       onClick={() => setResponsibilityOpen(!responsibilityOpen)}
      >
       Cerca
      </div>
     </div>
    ) : (
     false
    )}
   </div>

   <div>
    <h3 className="about_main-title">
     Detalles de contacto<br />
     C. Francisco I. Madero 41-41, Centro, 99000 Fresnillo, Zac. <br />
     Nuestro número: +524939328266
    </h3>
   </div>
  </div>
 );
};
export default observer(AboutUs);
